<template>
  <div class="hpanel" id="suggestions" v-if="listType !== 'aichat'">
      <div class="panel-heading" style="background-color: transparent;min-height: 40.5px">
        Suggestions
      </div>
      <div  class="panel-body">
        <span class="font-bold text-justify">Use to refine or expand current search</span>
        <template v-if="searchState === 2">
          <div class="table-responsive table-suggestion" style="overflow: auto;margin: 10px -10px 10px 0;min-height: 200px" :style="{maxHeight: suggestionHeight + 'px'}">
            <table class="table-condensed" style="width: 100%" v-if="localSuggestions.length !== 0">
              <tbody >
              <tr class="suggestion" v-for="(suggestion, key) in localSuggestions"
                  :key="suggestion.name + suggestion.nbResults + suggestion.followSearchId" :id="key === 0 ? 'first' : ''"
                  v-if="suggestionName(suggestion.name) !== suggestionName(query)" >
                <td>
                <span class="" data-container="body" data-toggle="popover" data-placement="right"
                      :data-content="suggestion.popover ? suggestion.popover.content : ''"
                      :data-title="suggestion.popover ? suggestion.popover.title : ''"
                      :data-template="suggestion.popover ? suggestion.popover.template : ''"
                      data-html="true"
                      data-trigger="focus"
                      :id="suggestionId(suggestion.name)">{{suggestionName(suggestion.name)}} <b v-if="suggestion.nbResults !== 0" class="suggestion-item-nb" >(~{{suggestion.nbResults}})</b>
                </span>
                </td>
                <td class="text-center" ref="help">
                  <i v-if="suggestion.followSearchId !== null" class="fas fa-star text-info" data-toggle="popover" :data-content="'Monitored suggestions'"></i>
               </td>
                <td class="text-center">
                  <dropdown-suggestion :suggestion="suggestion.name" :refineSearch="refineSearch"
                                       :addSuggestionToBiblio="addSuggestionToBiblio" :onlySearch="onlySearch"
                                       :followSuggestion="followSuggestion" :unFollowSuggestion="unFollowSuggestion"
                                       :followSearchId="suggestion.followSearchId"/>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-else class="alert-warning p-xs m-t-md">
              <div><i class="fa fa-exclamation-triangle fa-1x"></i> No suggestion.</div>
            </div>
          </div>
        </template>
        <template v-else-if="searchState === 1">
          <div class="progress full m-t-xs" style="margin: 40px 0">
            <div class="progress-bar progress-bar-striped active progress-bar-info" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">
            </div>
          </div>
        </template>
      </div>
  </div>
</template>

<style scoped>
  .table > tbody > tr > td {
    vertical-align: middle;
    border-top: 0px solid #ddd;
    padding: 5px 5px;
    font-size: 12px;
  }

  .dropdown > ul > li i{
    color: #62cb31;
    font-weight: bold;
  }

  ::-webkit-scrollbar {
    width: 4px;
    height: 8px;
  }

</style>
<style>

  #tab-6  ul > li {
    background-color: #eaeaea;
  }
  .popover-wiki-search {
    min-width: 240px;
    max-width: 350px;
  }

  .popover-wiki-search .popover-content .searchmatch {
    font-weight: bold;
  }

  .popover-wiki-search .popover-content ul {
    padding: 5px;
    list-style-type: none;
  }

  .popover-wiki-search .popover-content li:hover {
    color: #3498db;
    cursor: pointer;
  }

  .popover-wiki-article {
    min-width: 500px;
    max-width: 700px;
    color: #3c3c3c;
  }

  .popover-wiki-article .wiki-thumbnail {
    float: right;
    height: 170px;
  }

  .popover-wiki-article .wiki-highlight {
    font-weight: bold;
  }
  .suggestion-item-nb {
    display: none;
  }
</style>
<script>

import DropdownSuggestion from './DropdownSuggestion'
import {hashCode} from '../../assets/scripts/utils'
import FollowSearch from '../Mixins/FollowSearch'

export default {
  mixins: [FollowSearch],
  components: {DropdownSuggestion},
  name: 'suggestionBox',
  props: ['suggestions', 'biblio', 'suggestionHeight', 'query', 'factor', 'searchState', 'showLimitPlan',
    'followedSearches', 'listId', 'listType'],
  watch: {
    suggestions: function (suggestions) {
      this.localSuggestions = []
      this.initWikipedia()
    },
    followedSearches: function (followedSearches) {
      this.identifyFollowedSearches()
    }
  },
  methods: {
    getNbResultSuggestion: function (suggestion) {
      return this.$requestStack.add('get', '/search/' + this.query + '/suggestion/' + suggestion.name, null, 2)
    },
    suggestionName: function (str) {
      return str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        }
      )
    },
    refineSearch: function (suggestion) {
      this.$eventHub.$emit('refineWithSuggestion', this.suggestionName(suggestion))
    },
    getCurrentUrlWithSuggestion: function (suggestion) {
      let url = this.$router.currentRoute.fullPath
      let captured = /usedByCs=([^&]+)/.exec(url)
      suggestion = encodeURIComponent(suggestion)
      suggestion = captured ? captured[1] + ',' + suggestion : suggestion
      if (captured) {
        return url.replace(('usedByCs=' + captured[1]), 'usedByCs=' + suggestion)
      } else {
        return (url.match(/\?/)) ? url + '&usedByCs=' + suggestion : url + '?usedByCs=' + suggestion
      }
    },
    addSuggestionToBiblio: function (suggestion) {
      if (this.$user.isBasic()) {
        this.showLimitPlan('saveSuggestion')
      } else if (typeof this.biblio !== 'undefined' && this.biblio !== null) {
        this.$requestStack.add('post', '/biblio/' + this.biblio.id + '/add/suggestion', {
          url: this.getCurrentUrlWithSuggestion(suggestion),
          title: suggestion
        }, 0).then((response) => {
          this.$notify({
            type: 'success',
            title: 'Suggestion added !',
            placement: 'bottom-right'
          })
          this.$eventHub.$emit('refreshBiblio', true)
          this.$salesMachine.addSuggToBiblio({suggestion: suggestion})
        })
      }
    },
    addWikiArticleToBiblio: function (wiki) {
      if (this.$user.isBasic()) {
        this.showLimitPlan('saveSuggestion')
      } else if (typeof this.biblio !== 'undefined' && this.biblio !== null) {
        this.$requestStack.add('post', '/biblio/' + this.biblio.id + '/add/wikiArticle', wiki, 0)
          .then((response) => {
            this.$notify({
              type: 'success',
              title: 'Article added !',
              placement: 'bottom-right'
            })
            this.$eventHub.$emit('refreshBiblio', true)
            this.$salesMachine.addWikiToBiblio({wiki: wiki})
          })
      }
    },
    onlySearch: function (suggestion) {
      this.$eventHub.$emit('onlySearchSuggestion', this.suggestionName(suggestion))
    },
    followSuggestion: function (suggestion) {
      this.mixinFollowSearch(suggestion, 'author', this.$parent.listIdSelected)
    },
    unFollowSuggestion: function (followSearchId) {
      this.mixinUnFollowSearch(followSearchId)
    },
    suggestionId: function (suggestion) {
      return hashCode(suggestion)
    },
    initWikipedia: function () {
      let keywords = []

      let kwToId = {}

      this.suggestions.forEach((suggestion) => {
        keywords.push(suggestion.name.toLowerCase())
        kwToId[suggestion.name] = hashCode(suggestion.name)
      })

      if (keywords.length !== 0) {
        $.ajax({
          dataType: 'json',
          url: this.urlWiki + '?origin=*&redirects=&action=query&format=json&titles=' + keywords.join('|'),
          cache: true
        }).then((data) => {
          let normalized = {}
          if (data.query.normalized.length !== 0) {
            data.query.normalized.forEach((val) => {
              normalized[val.to] = val.from
            })
          }

          // Load the redirects dictionary from the response data
          let redirects = {}
          if (typeof data.query.redirects !== 'undefined' && data.query.redirects.length !== 0) {
            data.query.redirects.forEach((val) => {
              redirects[val.to] = val.from
            })
          }

          Object.keys(data.query.pages).forEach((val) => {
            let page = data.query.pages[val]
            // Rebuild the original keyword
            let keyword = page.title
            if (redirects[keyword]) {
              keyword = redirects[keyword]
            }
            if (normalized[keyword]) {
              keyword = normalized[keyword]
            }
            keyword = keyword.toUpperCase()
            let id = kwToId[keyword]

            let pageid = page.pageid
            let type = (typeof pageid === 'undefined') ? 'search' : 'page'

            this.wikiArticles[id] = {'pageid': pageid, content: '', title: page.title, 'type': type, search: {}}
          })

          Promise.all([this.getWikipediaArticles(), this.searchWikiForRelated()]).then(() => {
            this.suggestions.forEach((suggestion, key) => {
              let id = hashCode(suggestion.name)
              let article = this.wikiArticles[id]
              suggestion.show = false
              suggestion.nbResults = '0'
              if (typeof article !== 'undefined') {
                this.wikiPopover(suggestion, article)
                suggestion.show = true
              }

              this.getNbResultSuggestion(suggestion).then((response) => {
                suggestion.nbResults = Math.round(response.data.total_results * this.factor)
                suggestion.followSearchId = null

                this.localSuggestions.push(suggestion)
                this.initPopover(suggestion.name)

                this.identifyFollowedSearches(suggestion)
              })

              return suggestion
            })
          })
        })
      }
    },
    getWikipediaArticles: function () {
      return new Promise((resolve, reject) => {
        let pageidTolabelId = {}

        Object.keys(this.wikiArticles).forEach((id) => {
          let article = this.wikiArticles[id]

          if (typeof article.pageid !== 'undefined') {
            pageidTolabelId[article.pageid] = id
          }
        })

        if (Object.keys(pageidTolabelId).length !== 0) {
          this.dbPedia('id', Object.keys(pageidTolabelId)).then((response) => {
            if (typeof response.results.bindings !== 'undefined') {
              this.addNewArticles(response.results.bindings)
            }
            resolve(null)
          }).catch((error) => {
            reject(error)
          })
        } else {
          resolve(null)
        }
      })
    },
    addNewArticles: function (bindings) {
      if (bindings) {
        let pageidTolabelId = {}
        Object.keys(this.wikiArticles).forEach((id) => {
          let article = this.wikiArticles[id]

          if (typeof article.pageid !== 'undefined') {
            pageidTolabelId[article.pageid] = id
          }
        })

        bindings.forEach((resource, index) => {
          let abstract = resource.abstract.value
          let thumbnail = null
          if (resource.thumbnail) {
            thumbnail = resource.thumbnail.value
          }

          let id = pageidTolabelId[parseInt(resource.pageid.value)]
          let article = this.wikiArticles[id]
          article.content = this.wikiArticlePopoverContent(abstract, article.title, thumbnail)
        })
      }
    },
    searchWikiForRelated: function () {
      let promises = []
      let articles = []

      return new Promise((resolve, reject) => {
        Object.keys(this.wikiArticles).forEach((id) => {
          let article = this.wikiArticles[id]

          if (article.type === 'search') {
            let data = {
              action: 'query',
              list: 'search',
              srsearch: article.title,
              srprop: 'titlesnippet',
              format: 'json'
            }

            let dataStr = Object.keys(data).map((key) => {
              return key + '=' + data[key]
            }).join('&')

            articles.push({article: article, id: id})

            promises.push($.ajax({
              dataType: 'json',
              url: this.urlWiki + '?origin=*&' + dataStr,
              cache: true
            }))
          }
        })

        this.axios.all(promises)
          .then(this.axios.spread((...args) => {
            for (let i = 0; i < args.length; i++) {
              let data = args[i]
              let article = articles[i].article
              let results = []

              if (typeof data.query !== 'undefined' && typeof data.query.search !== 'undefined' && data.query.search.length) {
                data.query.search.forEach((val, index) => {
                  results.push({'snippet': val.titlesnippet, 'title': val.title, 'pageid': val.pageid})
                })

                let id = articles[i].id

                article.content = this.wikiSearchPopoverContent(results, id)
              }
            }
            resolve(null)
          }))
      })
    },
    dbPedia: function (type, elements) {
      return new Promise((resolve, reject) => {
        let queryTemplate
        let filter

        if (elements.length !== 0) {
          switch (type) {
            case 'id':
              queryTemplate = 'PREFIX dbpedia-owl: <http://dbpedia.org/ontology/> select ?pageid ?abstract ?thumbnail where {?resource dbpedia-owl:wikiPageID ?pageid ; dbpedia-owl:abstract ?abstract . OPTIONAL { ?resource dbpedia-owl:thumbnail ?thumbnail } FILTER( ?pageid = %FILTER% ) filter(langMatches(lang(?abstract),"en"))}'
              filter = elements.join(' || ?pageid = ')
              break
            case 'title':
              elements.forEach((val, index) => {
                elements[index] = val.split(' ').join('_')
              })
              queryTemplate = 'PREFIX dbpedia-owl: <http://dbpedia.org/ontology/> PREFIX rdfs:  <http://www.w3.org/2000/01/rdf-schema#> select ?label ?abstract ?thumbnail where {?resource rdfs:label ?label ; dbpedia-owl:abstract ?abstract . OPTIONAL { ?resource dbpedia-owl:thumbnail ?thumbnail } FILTER( ?resource = <http://dbpedia.org/resource/%FILTER%> ) filter(langMatches(lang(?abstract),"en")) filter(langMatches(lang(?label),"en"))}'
              filter = elements.join('> || ?resource = <http://dbpedia.org/resource/')
              break
          }

          let data = {
            'default-graph-uri': 'http://dbpedia.org',
            query: queryTemplate.replace('%FILTER%', filter),
            format: 'application/json',
            timeout: 10
          }

          let dataStr = Object.keys(data).map((key) => {
            return key + '=' + data[key]
          }).join('&')

          $.ajax({
            dataType: 'json',
            url: this.urlDbPedia + '?' + dataStr,
            cache: true
          }).then((response) => {
            resolve(response)
          })
            .catch((error) => {
              reject(error)
            })
        } else {
          resolve([])
        }
      })
    },
    wikiArticlePopoverContent: function (abstract, title, thumbnail) {
      // Truncate the abstract if it's too long
      let maxlength = 1000
      if (abstract.length > maxlength) {
        // A regex is used to truncate at the end of a sentence.
        let pattern = '^.{0,' + maxlength + '}[\\.]'
        let regEx = new RegExp(pattern, 'gi')
        let re = abstract.match(regEx)
        abstract = re !== null ? re[0] + ' (&hellip;)' : abstract
      }

      // Highlight the title of the article in the abstract
      let template = '<span class="wiki-highlight">%s</span>'
      let pattern = '(' + title.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').split(' ').join(' |') + ')+'
      let titleRegEx = new RegExp(pattern, 'i')
      abstract = abstract.replace(titleRegEx, function (matched) {
        let r = template.replace('%s', matched)
        return r
      })
      abstract = '<span>' + abstract + '</span>'

      // Add the thumbnail
      if (thumbnail !== null && thumbnail.length) {
        abstract = '<img class="wiki-thumbnail" height="170" src="' + thumbnail + '">' + abstract
      }

      return '<div class="clearfix">' + abstract + '</div>'
    },
    wikiSearchPopoverContent: function (searchResults, parentId) {
      let content = $('<ul class="data-parent-id-' + parentId + '">')
      searchResults.forEach((val, index) => {
        let title = val.title
        let id = hashCode(title)
        let searchSnippet = $('<li class="data-page-wiki-id-' + val.pageid + '"></li>').addClass('wiki-search-result').addClass('fixed')
        searchSnippet.attr('id', id)
        if (typeof val.snippet !== 'undefined' && val.snippet.length) {
          searchSnippet.html(val.snippet)
        } else {
          searchSnippet.html(title)
        }
        content.append(searchSnippet.clone())
      })
      return $('<div>').append(content.clone()).html()
    },
    wikiPopover: function (suggestion, article, selector) {
      let popoverContent = article.content
      if (popoverContent.length) {
        let wikiURL = 'https://en.wikipedia.org/wiki/' + encodeURIComponent(article.title)
        let popoverTitle
        let popoverClass
        if (article.type === 'page') {
          let wikiLinkText = 'View full article'
          popoverTitle = '<div class="row">' +
              '<div class="col-xs-4 text-left"><a href="' + wikiURL + '" target="_blank" class="btn btn-info btn-outline wiki-article-link">' + wikiLinkText + '</a></div>' +
              '<div class="col-xs-4 text-center m-t-sm">Wikipedia article</div>'
          if (this.$user.isBasic()) {
            popoverTitle += '<div class="col-xs-4 text-right"><a class="saveToBiblio btn btn-info">Save to Biblio <i class="fa fa-lock font-bold"></i></a>'
          } else {
            popoverTitle += '<div class="col-xs-4 text-right"><a class="saveToBiblio btn btn-info">Save to Biblio</a>'
          }
          popoverTitle += '<div class="hidden" id="wiki-url">' + wikiURL + '</div>' +
              '<div class="hidden" id="article-title">' + article.title + '</div>' +
              '<div class="hidden" id="article-content">' + popoverContent + '</div>' +
              '</div>' +
              '</div>'

          popoverClass = 'popover-wiki-article'
        } else if (article.type === 'search') {
          popoverTitle = 'Related Wikipedia articles'
          popoverClass = 'popover-wiki-search'
        }

        let template = '<div class="popover ' + popoverClass + '">' +
            '<div class="arrow"></div>' +
            '<div class="popover-title"></div>' +
            '<div class="popover-content"></div>' +
            '</div>'
        if (suggestion !== null) {
          suggestion.popover = {
            template: template,
            title: popoverTitle,
            content: popoverContent
          }
        } else {
          $(selector).popover({
            template: template,
            trigger: 'hover',
            placement: 'right',
            content: popoverContent,
            html: true,
            title: popoverTitle,
            container: $(selector)
          })
        }

        $(document).off('click', '.saveToBiblio')
        $(document).on('click', '.saveToBiblio', (e) => {
          let wikiTitle = null
          let wikiUrl = null
          let wikiDefinitionContent = null

          $(e.target)[0].parentElement.childNodes.forEach((element) => {
            let id = element.id
            let innerText = element.innerText

            if (id === 'wiki-url') {
              wikiUrl = innerText
            } else if (id === 'article-title') {
              wikiTitle = innerText
            } else if (id === 'article-content') {
              wikiDefinitionContent = innerText
            }
          })
          let wiki = {'title': wikiTitle, 'url': wikiUrl, 'description': wikiDefinitionContent}

          this.addWikiArticleToBiblio(wiki)
        })
        $(document).off('click', '.wiki-article-link')
        $(document).on('click', '.wiki-article-link', (e) => {
          let win = window.open(e.target.href, '_blank')
          win.focus()
          e.preventDefault()
        })
      }
    },
    initPopover: function (suggestion) {
      $(() => {
        $('#' + this.suggestionId(suggestion)).each((index, element) => {
          $(element).popover({
            trigger: 'hover',
            html: true,
            animation: false,
            container: $(element)
          })
        })
        $('#' + this.suggestionId(suggestion)).on('shown.bs.popover', (e) => {
          let pagesId = []

          let id = $(e.target).attr('id')
          $('.data-parent-id-' + id).children().each((index, wikiSuggestion) => {
            let title = $(wikiSuggestion).text()
            let id = hashCode(title)

            let regex1 = /data-page-wiki-id-(-*\d+)/
            let result = regex1.exec($(wikiSuggestion).attr('class'))

            let pageid = result[1]

            if (typeof this.wikiArticles[id] === 'undefined') {
              this.wikiArticles[id] = {'pageid': pageid, content: '', title: title, type: 'page', search: {}}
              pagesId.push(pageid)
            } else {
              let article = this.wikiArticles[id]
              this.wikiPopover(null, article, $('.data-page-wiki-id-' + article.pageid))
            }
          })

          this.dbPedia('id', pagesId).then((response) => {
            if (typeof response.results.bindings !== 'undefined') {
              this.addNewArticles(response.results.bindings)

              pagesId.forEach((pageId) => {
                let articleId = Object.keys(this.wikiArticles).find((id) => {
                  return this.wikiArticles[id].pageid === pageId.toString()
                })
                let article = this.wikiArticles[articleId]

                this.wikiPopover(null, article, $('data-page-wiki-id-' + pageId))
              })
            }
          }).catch((error) => {
          })
        })
      })
    },
    identifyFollowedSearches: function (suggestion) {
      let followSearch = null

      if (typeof suggestion === 'undefined') {
        this.localSuggestions.forEach((suggestion, key) => {
          followSearch = this.getFollowedSearch(suggestion.name)

          suggestion.followSearchId = followSearch === null ? null : followSearch.id
          this.$set(this.localSuggestions, key, suggestion)
        })
      } else {
        followSearch = this.getFollowedSearch(suggestion.name)

        if (followSearch !== null) {
          let index = this.localSuggestions.findIndex((tmpSuggestion) => {
            return tmpSuggestion.name === suggestion.name
          })

          if (index !== null) {
            suggestion.followSearchId = followSearch.id
            this.$set(this.localSuggestions, index, suggestion)
          }
        }
      }

      if (typeof this.$refs.help !== 'undefined') {
        setTimeout(() => {
          $(this.$refs.help).find('[data-toggle="popover"]').popover({
            trigger: 'hover',
            placement: 'top'
          })
        }, 500)
      }
    },
    getFollowedSearch: function (suggestion) {
      let followedSearchFound = null

      this.followedSearches.forEach((followedSearch) => {
        let search = followedSearch.search_terms.term.replace(/"/gi, '').toLowerCase()

        if (search === suggestion.toLowerCase()) {
          followedSearchFound = followedSearch
          return true
        }
      })
      return followedSearchFound
    }
  },
  data () {
    return {
      wikiArticles: {},
      localSuggestions: [],
      urlWiki: null,
      urlDbPedia: null
    }
  },
  beforeMount () {
    this.urlWiki = 'https://en.wikipedia.org/w/api.php'
    this.urlDbPedia = 'https://dbpedia.org/sparql'
  },
  mounted () {
    this.initWikipedia()

    // $('.table-responsive.table-suggestion').on('show.bs.dropdown', function () {
    //   $('.table-suggestion').css('overflow', 'auto')
    // })
    //
    // $('.table-responsive.table-suggestion').on('hide.bs.dropdown', function () {
    //   $('.table-suggestion').css('overflow', 'auto')
    // })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/suggestion/SuggestionBox.vue